import React from 'react';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';

const PdpDescriptionSkeleton = () => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 414, h: 1718 }
    : { w: 978, h: 927 };

  return (
    <div>
      <PlaceholderLoader
        width={width}
        height={height}
        uid="cardSkeleton"
        style={{ height: '100%', width: '100%', display: 'block' }}
      >
        {mobile ? (
          <>
            <rect x="200" y="1042" width="110" height="17" rx="8.5" />
            <rect x="200" y="1141" width="180" height="17" rx="8.5" />
            <rect x="200" y="1172" width="180" height="17" rx="8.5" />
            <rect x="200" y="1207" width="152" height="18" rx="9" />
            <rect x="200" y="1238" width="180" height="17" rx="8.5" />
            <rect x="226" y="1097" width="148" height="21" rx="8" />
            <rect x="226" y="998" width="106" height="21" rx="8" />
            <ellipse cx="210" cy="1008.5" rx="10" ry="10.5" />
            <rect x="200" y="1533" width="110" height="17" rx="8.5" />
            <rect x="226" y="1489" width="106" height="21" rx="8" />
            <ellipse cx="210" cy="1499.5" rx="10" ry="10.5" />
            <ellipse cx="210" cy="1107.5" rx="10" ry="10.5" />
            <rect x="200" y="1335" width="180" height="17" rx="8.5" />
            <rect x="200" y="1367" width="180" height="17" rx="8.5" />
            <rect x="200" y="1402" width="152" height="17" rx="8.5" />
            <rect x="200" y="1433" width="180" height="17" rx="8.5" />
            <rect y="51" width="391" height="17" rx="8.5" />
            <rect y="79" width="414" height="17" rx="8.5" />
            <rect y="108" width="375" height="17" rx="8.5" />
            <rect y="136" width="414" height="18" rx="9" />
            <rect y="165" width="358" height="17" rx="8.5" />
            <rect y="194" width="414" height="17" rx="8.5" />
            <rect y="326" width="358" height="18" rx="9" />
            <rect y="355" width="414" height="17" rx="8.5" />
            <rect y="223" width="297" height="18" rx="9" />
            <rect y="296" width="391" height="17" rx="8.5" />
            <rect y="383" width="391" height="17" rx="8.5" />
            <rect y="411" width="370" height="18" rx="9" />
            <rect y="440" width="414" height="17" rx="8.5" />
            <rect y="468" width="398" height="17" rx="8.5" />
            <rect y="497" width="414" height="17" rx="8.5" />
            <rect y="525" width="297" height="17" rx="8.5" />
            <rect y="725" width="391" height="18" rx="9" />
            <rect y="754" width="370" height="17" rx="8.5" />
            <rect y="783" width="414" height="17" rx="8.5" />
            <rect y="810" width="398" height="18" rx="9" />
            <rect y="840" width="414" height="17" rx="8.5" />
            <rect y="868" width="297" height="17" rx="8.5" />
            <rect y="567" width="370" height="17" rx="8.5" />
            <rect y="596" width="414" height="17" rx="8.5" />
            <rect y="623" width="398" height="17" rx="8.5" />
            <rect y="653" width="414" height="17" rx="8.5" />
            <rect y="681" width="297" height="17" rx="8.5" />
            <rect y="265" width="414" height="18" rx="9" />
            <rect x="226" y="1291" width="148" height="21" rx="8" />
            <ellipse cx="210" cy="1301.5" rx="10" ry="10.5" />
            <rect x="200" y="1634" width="180" height="17" rx="8.5" />
            <rect x="200" y="1666" width="180" height="17" rx="8.5" />
            <rect x="200" y="1701" width="152" height="17" rx="8.5" />
            <rect x="226" y="1590" width="148" height="21" rx="8" />
            <ellipse cx="210" cy="1600.5" rx="10" ry="10.5" />
            <rect y="1042" width="107" height="17" rx="8.5" />
            <rect y="1141" width="177" height="17" rx="8.5" />
            <rect y="1172" width="177" height="17" rx="8.5" />
            <rect y="1207" width="150" height="18" rx="9" />
            <rect y="1238" width="177" height="17" rx="8.5" />
            <rect x="25" y="1097" width="146" height="21" rx="8" />
            <rect x="25" y="998" width="105" height="21" rx="8" />
            <rect y="937" width="142" height="27" rx="8" />
            <rect width="142" height="27" rx="8" />
            <ellipse cx="9" cy="1008.5" rx="9" ry="10.5" />
            <rect y="1533" width="107" height="17" rx="8.5" />
            <rect x="25" y="1489" width="105" height="21" rx="8" />
            <ellipse cx="9" cy="1499.5" rx="9" ry="10.5" />
            <ellipse cx="9" cy="1107.5" rx="9" ry="10.5" />
            <rect y="1335" width="177" height="17" rx="8.5" />
            <rect y="1367" width="177" height="17" rx="8.5" />
            <rect y="1402" width="150" height="17" rx="8.5" />
            <rect y="1433" width="177" height="17" rx="8.5" />
            <rect x="25" y="1291" width="146" height="21" rx="8" />
            <ellipse cx="9" cy="1301.5" rx="9" ry="10.5" />
            <rect y="1634" width="177" height="17" rx="8.5" />
            <rect y="1666" width="177" height="17" rx="8.5" />
            <rect y="1701" width="150" height="17" rx="8.5" />
            <rect x="25" y="1590" width="146" height="21" rx="8" />
            <ellipse cx="9" cy="1600.5" rx="9" ry="10.5" />
          </>
        ) : (
          <>
            <rect x="773" y="110" width="125" height="18" rx="9" />
            <rect x="773" y="213" width="205" height="18" rx="9" />
            <rect x="773" y="246" width="205" height="18" rx="9" />
            <rect x="773" y="283" width="174" height="18" rx="9" />
            <rect x="773" y="315" width="205" height="18" rx="9" />
            <rect x="802" y="167" width="170" height="22" rx="8" />
            <rect x="802" y="64" width="122" height="22" rx="8" />
            <circle cx="784" cy="75" r="11" />
            <rect x="773" y="624" width="125" height="18" rx="9" />
            <rect x="802" y="578" width="122" height="22" rx="8" />
            <circle cx="784" cy="589" r="11" />
            <circle cx="784" cy="178" r="11" />
            <rect x="773" y="417" width="205" height="18" rx="9" />
            <rect x="773" y="450" width="205" height="18" rx="9" />
            <rect x="773" y="487" width="174" height="18" rx="9" />
            <rect x="773" y="519" width="205" height="18" rx="9" />
            <rect y="53" width="449" height="18" rx="9" />
            <rect y="83" width="475" height="18" rx="9" />
            <rect y="113" width="430" height="18" rx="9" />
            <rect y="143" width="475" height="18" rx="9" />
            <rect y="173" width="410" height="18" rx="9" />
            <rect y="203" width="475" height="18" rx="9" />
            <rect y="342" width="410" height="18" rx="9" />
            <rect y="372" width="475" height="18" rx="9" />
            <rect y="234" width="341" height="18" rx="9" />
            <rect y="310" width="449" height="18" rx="9" />
            <rect y="401" width="449" height="18" rx="9" />
            <rect y="431" width="425" height="18" rx="9" />
            <rect y="461" width="475" height="18" rx="9" />
            <rect y="490" width="456" height="18" rx="9" />
            <rect y="521" width="475" height="18" rx="9" />
            <rect y="550" width="341" height="18" rx="9" />
            <rect y="760" width="449" height="18" rx="9" />
            <rect y="790" width="425" height="18" rx="9" />
            <rect y="820" width="475" height="18" rx="9" />
            <rect y="849" width="456" height="18" rx="9" />
            <rect y="880" width="475" height="18" rx="9" />
            <rect y="909" width="341" height="18" rx="9" />
            <rect y="594" width="425" height="18" rx="9" />
            <rect y="624" width="475" height="18" rx="9" />
            <rect y="653" width="456" height="18" rx="9" />
            <rect y="684" width="475" height="18" rx="9" />
            <rect y="713" width="341" height="18" rx="9" />
            <rect y="278" width="475" height="18" rx="9" />
            <rect x="802" y="371" width="170" height="22" rx="8" />
            <circle cx="784" cy="382" r="11" />
            <rect x="773" y="730" width="205" height="18" rx="9" />
            <rect x="773" y="763" width="205" height="18" rx="9" />
            <rect x="773" y="800" width="174" height="18" rx="9" />
            <rect x="802" y="684" width="170" height="22" rx="8" />
            <circle cx="784" cy="695" r="11" />
            <rect x="543" y="110" width="123" height="18" rx="9" />
            <rect x="543" y="213" width="202" height="18" rx="9" />
            <rect x="543" y="246" width="202" height="18" rx="9" />
            <rect x="543" y="283" width="172" height="18" rx="9" />
            <rect x="543" y="315" width="202" height="18" rx="9" />
            <rect x="571" y="167" width="168" height="22" rx="8" />
            <rect x="571" y="64" width="121" height="22" rx="8" />
            <rect x="543" width="164" height="28" rx="8" />
            <rect width="164" height="28" rx="8" />
            <ellipse cx="553.5" cy="75" rx="10.5" ry="11" />
            <rect x="543" y="624" width="123" height="18" rx="9" />
            <rect x="571" y="578" width="121" height="22" rx="8" />
            <ellipse cx="553.5" cy="589" rx="10.5" ry="11" />
            <ellipse cx="553.5" cy="178" rx="10.5" ry="11" />
            <rect x="543" y="417" width="202" height="18" rx="9" />
            <rect x="543" y="450" width="202" height="18" rx="9" />
            <rect x="543" y="487" width="172" height="18" rx="9" />
            <rect x="543" y="519" width="202" height="18" rx="9" />
            <rect x="571" y="371" width="168" height="22" rx="8" />
            <ellipse cx="553.5" cy="382" rx="10.5" ry="11" />
            <rect x="543" y="730" width="202" height="18" rx="9" />
            <rect x="543" y="763" width="202" height="18" rx="9" />
            <rect x="543" y="800" width="172" height="18" rx="9" />
            <rect x="571" y="684" width="168" height="22" rx="8" />
            <ellipse cx="553.5" cy="695" rx="10.5" ry="11" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
};

export default PdpDescriptionSkeleton;
